/**
 * PaymentReturnPage — после возврата от ЮKassa.
 * Маршрут: /cabinet/payment/return
 *
 * ЮKassa редиректит сюда после оплаты. Webhook параллельно обновляет статус
 * на бэкенде. Мы здесь просто сообщаем "платёж обрабатывается" и предлагаем
 * вернуться на дашборд через несколько секунд.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Container, Paper, Stack, Text, Title, Button, Center, Loader,
} from '@mantine/core';
import { IconCheck, IconArrowRight } from '@tabler/icons-react';
import tokens from '../theme/designTokens';

const PaymentReturnPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(timer);
          navigate('/');
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <Box style={{ minHeight: '100vh', background: tokens.colors.bg.page, paddingTop: 100 }}>
      <Container size="xs">
        <Paper p="xl" radius="xl" shadow="md" style={{ background: 'white', textAlign: 'center' }}>
          <Stack gap="md" align="center">
            <Box
              style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: tokens.gradients.softGreen,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: tokens.colors.brand.green,
              }}
            >
              <IconCheck size={40} stroke={3} />
            </Box>

            <Title
              order={3}
              style={{
                fontFamily: tokens.typography.fontFamilyHeading,
                color: tokens.colors.text.primary,
              }}
            >
              Спасибо за оплату!
            </Title>

            <Text c={tokens.colors.text.muted} fw={700} size="sm">
              Платёж обрабатывается. Чек на оплату придёт вам на email
              в течение нескольких минут.
            </Text>

            <Center>
              <Loader size="sm" color="brand-purple" />
            </Center>

            <Text size="xs" c={tokens.colors.text.muted} fw={700}>
              Перенаправление через {countdown}…
            </Text>

            <Button
              fullWidth
              size="lg"
              color="brand-orange"
              rightSection={<IconArrowRight size={18} />}
              onClick={() => navigate('/')}
            >
              Вернуться в кабинет
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default PaymentReturnPage;
